'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var nullAction = {
  type: '__NULL_ACTION__'
};

exports.default = nullAction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/zeal-redux-utils/lib/nullAction.js
// module id = 1203
// module chunks = 0